import _ from 'lodash';
import React from "react";
import { connect as reduxConnect } from "react-redux";
import { connect as formikConnect } from 'formik';
import { compose } from "redux";
import NumberFormat from 'react-number-format';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dropdown from '../../../Global/Dropdown/Dropdown';
import AddButton from '../../../Global/Buttons/AddButton';
import CloseButton from '../../../Global/Buttons/CloseButton';
import { ChildSectionTitle } from '../FormSectionComponents';

const styles = () => ({
  emptyGrid: {
    padding: '12px',
    alignSelf: 'stretch',
    background: '#f2f2f2',
    color: '#999999'  
  },
  inputField: {
    borderBottom: "1px solid #2196F3"
  },
  propertyDropdown: {
    paddingTop: '13px'
  }
});

class LoanPropertyLinkChildSection extends React.Component {
  static percentFormattedTextBox(props) {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange(values.floatValue);
        }}
        allowNegative={false}
        suffix="%"
        fixedDecimalScale
        decimalScale={0}
      />
    );
  }

  renderLoanPropertyEdit = (loanProperty, dealPropertiesList) => {
    return (
      <Grid item container direction="row" alignItems="center" spacing={16}>
        <Grid item xs={3}>
          <Dropdown
            isSearchable
            options={dealPropertiesList}
            selectedValue={loanProperty.propertyId}
            onChange={selectedOption => {
              loanProperty.propertyId = selectedOption.value;
              this.forceUpdate();
            }}
            className={this.props.classes.propertyDropdown}
          />
        </Grid>
        <Grid item>
          <TextField
            type="text"
            label="Percent Allocated"
            className={this.props.classes.inputField}
            value={loanProperty.allocationPercent * 100}
            onChange={value => {
              loanProperty.allocationPercent = value / 100;
              this.forceUpdate();
            }}
            InputProps={{ 
              inputComponent: LoanPropertyLinkChildSection.percentFormattedTextBox,
              disableUnderline: true
             }}
          />
        </Grid>
        <Grid item>
          <CloseButton onClick={() => {
            _.pull(this.props.formik.values.properties, loanProperty);
            this.forceUpdate();
          }} />
        </Grid>
      </Grid>
    );
  };

  renderLoanPropertyDisplay = (loanProperty) => {
    const selectedDealProperty = _.first(this.props.dealProperties.filter(x => x.id === loanProperty.propertyId));

    return (
      <Grid item container direction="row" spacing={32}>
        <Grid item xs={3}>
          {selectedDealProperty && `${selectedDealProperty.name} - ${selectedDealProperty.address}`}
        </Grid>
        <Grid item>
          <NumberFormat value={loanProperty.allocationPercent * 100} displayType="text" suffix="%" decimalScale={0} />
        </Grid>
      </Grid>
    );
  }

  render() {
    const properties = this.props.formik.values.properties;
    if (!properties || !this.props.dealProperties) {
      return null;
    }
    const dealPropertiesList = this.props.dealProperties.map(property => ({ value: property.id, label: `${property.name} - ${property.address}` }));

    return (
      <>
        <div id="loan_section_property_allocation">
          <ChildSectionTitle>Property Allocations</ChildSectionTitle>
          {properties.length === 0 && (
            <div className={this.props.classes.emptyGrid}>There are no properties associated with this loan.</div>
          )}
          <Grid container direction="column">
            {properties && properties.map(loanProperty =>
              this.props.isEditing
              ? this.renderLoanPropertyEdit(loanProperty, dealPropertiesList)
              : this.renderLoanPropertyDisplay(loanProperty)
            )}
          </Grid>
          {this.props.isEditing && (
            <AddButton
              title="Add Allocation"
              onClick={() => {
                properties.push({});
                this.forceUpdate();
              }}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = () => ({});

LoanPropertyLinkChildSection.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dealProperties: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isEditing: PropTypes.bool.isRequired,
  isQuote: PropTypes.bool.isRequired,
  classes: PropTypes.shape({}).isRequired
};

export default compose(
  formikConnect,
  reduxConnect(mapStateToProps, {}),
  withStyles(styles)
)
(LoanPropertyLinkChildSection);
